<template>	
	<div class="calendly-inline-widget" data-url="https://calendly.com/walterlaupickleball/lesson" style="min-width:320px;height:700px;"></div>	
</template>



<script>
import { initTooltips, initDropdowns  } from "flowbite"
import {onMounted, ref} from 'vue'


export default {
    setup(){
        const dropDowner = ref(['mario', 'lugio', 'peach'])
        const memberTest = ref([
            {id: 1, first: 'billy', last: 'gaonzo', email: 'ger@gmail.com'},            
            {id: 2, first: 'bozo', last: 'sfeged', email: 'gdfeer@gmail.com'}
        ])
        
        const keymaster = Object.keys(memberTest.value[0])
		onMounted(() => {
			const script = document.createElement('script');
			script.src = 'https://assets.calendly.com/assets/external/widget.js';
			script.async = true;
			document.head.appendChild(script);
		});
        

        // onMounted(()=>{ initTooltips(), initDropdowns();})

        return {dropDowner, memberTest}
    }    
}
</script>

<style>

</style>